import { ApplicationModel } from './application_model.js';

export class Config extends ApplicationModel {
  static tableName = 'key-val';
  static primaryKey = 'key'
  static externalId = true;
  static attributes = this.attrAccessor(
    'lastBackupAt',
  )

  get shouldPresentBackupNudge() {
    if(this.backupNudgePresented) return false;

    const days = 7;
    const daysInMilliseconds = days * 24 * 60 * 60 * 1000;

    const d = new Date();
    const duringDay = d.getHours() > 10 && d.getHours() < 23;

    const shouldShow = duringDay && (this.lastBackupAt || 0) < Date.now() - daysInMilliseconds;

    return shouldShow;
  }
}


window.Config = Config;
